<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <a class="close-btn cursor-pointer" (click)="close()" aria-label="Close dialog">
      <i class="ri-close-line"></i>
    </a>
  </div>

  <mat-dialog-content class="p-0">
    <div class="text-center">
      <form novalidate (ngSubmit)="confirmVerification()">
        <!-- Glowing Circular Icon -->
        <div class="modal-icon-badge mx-auto mb-3">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
        </div>

        <h4 class="modal-title mb-1">Verify Set</h4>
        <p class="modal-subtitle mb-4">
          Mark <span class="set-name-badge">{{ setName }}</span> as manually verified.
        </p>

        <!-- Form Fields Container -->
        <div class="form-fields-container text-start mb-4">
          <!-- Verify Date Field -->
          <div class="field-item mb-3">
            <label class="field-label d-block mb-2">
              VERIFY DATE <span class="text-danger">*</span>
            </label>
            <mat-form-field appearance="outline" class="w-100 verify-date-field">
              <input
                matInput
                [matDatepicker]="verifiedDatePicker"
                [(ngModel)]="verifiedDate"
                name="verifiedDate"
                placeholder="DD/MM/YYYY"
                [max]="maxDate"
                required
                readonly
                (click)="verifiedDatePicker.open()"
              />
              <mat-datepicker-toggle matIconSuffix [for]="verifiedDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #verifiedDatePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Verifier Name Field -->
          <div class="field-item mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label for="verifiedByName" class="field-label m-0">
                VERIFIER NAME <span class="text-danger">*</span>
              </label>
              <span class="field-counter">{{ verifiedByName.length }}/{{ verifierNameMaxLength }}</span>
            </div>
            <input
              id="verifiedByName"
              name="verifiedByName"
              type="text"
              class="form-control field-input"
              [(ngModel)]="verifiedByName"
              placeholder="Enter verifier name"
              [maxlength]="verifierNameMaxLength"
              required
              autocomplete="off"
            />
          </div>

          <!-- Interactive Confirmation Checkbox Card -->
          <div class="confirm-check-card mb-3" [class.checked]="cardsCheckedConfirmed" (click)="cardsCheckedConfirmed = !cardsCheckedConfirmed">
            <div class="confirm-checkbox-box" (click)="$event.stopPropagation()">
              <mat-checkbox
                [(ngModel)]="cardsCheckedConfirmed"
                name="cardsCheckedConfirmed">
              </mat-checkbox>
            </div>
            <span class="confirm-check-text">
              I confirm all cards have been checked and any required manual amendments completed
            </span>
          </div>

          <!-- Notes Field -->
          <div class="field-item mb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label for="verificationNotes" class="field-label m-0">
                NOTES
              </label>
              <span class="field-counter">{{ (verificationNotes || '').length }}/{{ notesMaxLength }}</span>
            </div>
            <textarea
              id="verificationNotes"
              name="verificationNotes"
              class="form-control field-textarea"
              rows="3"
              placeholder="Summary of what had to change, if anything..."
              [(ngModel)]="verificationNotes"
              [maxlength]="notesMaxLength"
            ></textarea>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="modal-actions d-flex align-items-center gap-3">
          <button type="button" class="btn-cancel" (click)="close()">
            Cancel
          </button>
          <button
            type="submit"
            class="btn-confirm"
            [disabled]="!canConfirm"
            (click)="confirmVerification()"
          >
            Confirm Verified
          </button>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</div>
